module.exports = "@charset \"UTF-8\";\n/* Przykład zmiennej */\n/* zmiany custom do przeniesienie do osobnego folderu */\n/* nav custom modyfication */\n/* ekran logowania */\n/*ranking*/\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./node_modules/sass-loader/lib/loader.js??ref--8-3!./src/environments/variables.scss
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./node_modules/sass-loader/lib/loader.js??ref--8-3!./src/environments/variables.scss
// module chunks = styles